export default class Filter
{
	constructor(data, params)
	{
		this.data = data

		this.params = params

		this.params.instantReload = this.params.instantReload || false;

		this.fields = [...this.params.el.$form.elements];
		this.checkboxFields = this.fields.filter(input => {
			return input.type.toLowerCase() == 'checkbox';
		});

		this.attachEvents()
		this.initComponents()
	}

	attachEvents()
	{
		this.params.el.$form.addEventListener('submit', (e) => {
			e.preventDefault()
			this.onSubmitSetfilter()
		})

		if (this.params.instantReload) {
			const fields = this.fields.filter(field => {
				return ['input', 'select'].includes(field.tagName.toLowerCase());
			});
			['keyup', 'change'].forEach(eventName => {
				this.params.el.$form.addEventListener(
					eventName,
					BX.debounce(({ target }) => {
						if (!this.params.instantReload || !fields.includes(target))
							return;

						this.params.el.$form.dispatchEvent(new Event('submit'));
					}, 600)
				);
			});
		} else {
			this.params.el.$form.reset_filter && this.params.el.$form.reset_filter.addEventListener('click', () => {
				this.onSubmitResetfilter()
			})
		}
	}

	initComponents()
	{
		this.initComponentTagsSearch()
		this.initComponentDateRange()
		this.initSelectFields()
	}

	onSubmitSetfilter()
	{
		let data = BX.ajax.prepareForm(this.params.el.$form).data

		this.checkboxFields.forEach(input => {
			if (!input.checked) {
				data[input.name] = '';
			}
		});

		BX.onCustomEvent(`filter-${this.params.filterName}-on-submit`, [data])
	}

	onSubmitResetfilter()
	{
		let data = BX.ajax.prepareForm(this.params.el.$form).data

		this.resetFormData()

		BX.onCustomEvent(`filter-${this.params.filterName}-on-reset`, [data])
	}

	initComponentTagsSearch()
	{
		if (!this.data || !this.data.tagssearch)
			return

		this.objTagss = {};
		for (let key in this.data.tagssearch)
		{
			this.objTagss[key] = new B2BPortal.Components.TagsSearch(this.data.tagssearch[key], this.params);
		}
	}

	initComponentDateRange()
	{
		if (!this.data || !this.data.daterange)
			return

		for (let key in this.data.daterange)
		{
			const datarange = this.data.daterange[key];
			$(datarange.selector).datepicker({
				format: datarange.format || 'dd.mm.yyyy',
				orientation: 'bottom right',
				autoclose: true,
				language: BX.Loc.getMessage('LANGUAGE_ID'),
			});
		}
	}

	initSelectFields()
	{
		this.selectFields = this.fields.filter(field => {
			return field.tagName.toLowerCase() == 'select';
		});

		this.selectFields.forEach(field => {
			$(field).selectpicker();
		});
	}

	resetFormData()
	{
		for (let key in this.objTagss)
		{
			this.objTagss[key].clearSearchItems()
		}

		let inputs = this.params.el.$form.querySelectorAll('input')
		inputs.forEach((input) => {
			input.value = ''
		})

		let selects = this.params.el.$form.querySelectorAll('select')
		selects.forEach((select) => {
			select.value = -1
		})
	}

}
